import { useStyle } from "lib/hooks";
import { splitValueUnit, classnames } from "lib/helpers";
import { processUnit } from "windows/Properties/components/BoxModel";
import { useEffect, forwardRef } from "react";
import _ from "lodash";

/**
 * input with div parent
 * needs to be ref'd by parent
 *
 * loads styles from component first
 * element style second
 */
// TODO: remove full
function Input(
  { placeholder, full, attr, onChange, loadStyle = true, onlyValue = true },
  ref
) {
  const [style, setStyle] = useStyle(attr, loadStyle);
  const _onChange = ({ target: { value } }) => {
    if (onChange) onChange();
    if (attr) setStyle(value);
  };
  const onKeyDown = ({ keyCode, target }) => {
    const { value, unit } = splitValueUnit(target.value, "px");
    // console.log(target.value, value, unit)
    let cValue = value + (keyCode === 38 ? 1 : -1);
    let cUnit = processUnit(cValue, unit);
    if (keyCode === 38 || keyCode === 40) {
      const value = cValue + cUnit;
      if (attr) setStyle(value);
      if (ref) ref.current.value = value;
      if (onChange) onChange();
    }
  };
  let defaultValue;
  if (onlyValue) {
    const attribute = splitValueUnit(style);
    defaultValue = attribute.value;
  } else {
    defaultValue = style;
  }
  useEffect(() => {
    // issue #6
    if (_.get(ref, "current")) {
      // see issue #1
      // also don't set undefined
      ref.current.value = defaultValue || "";
      // not sure if should use directly
      // ref.current.value = style || '';
    }
  }, [ref, attr, defaultValue]);
  return (
    <div className={classnames("vc", { f: full })}>
      <input
        type="text"
        {...{ placeholder, ref, onKeyDown }}
        onChange={_onChange}
      />
    </div>
  );
}

export default forwardRef(Input);
